import React, { Component} from 'react';
import styled from 'styled-components';

import WP from 'WP';

import InputField from './InputField';
import GridElement from 'partials/GridElement';

import Media from 'css/Media';

class ContactForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: true,
            lastName: true,
            phone: true,
            adress: true,
            postalCode: true,
            city: true,
            validEmailFormat: true,
        }
    }

    validateField = e => {
        if(this.props.personalia[e.target.name].length) {
            this.setState({[e.target.name]: true})
        } else this.setState({[e.target.name]: false})
    }

    validateEmailFormat = (e) => {        
        let regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.setState({
            validEmailFormat: regEx.test(String(e.target.value).toLowerCase())
        })
    }
        
    render() {
        const { validEmailFormat } = this.state;
        const {
            id,
            submitted,
            personalia,
        } = this.props;
        const {
            firstName,
            lastName,
            email,
            phone,
            adress,
            postalCode,
            city,
        } = personalia;

        return(
            <FormGrid id={id}>
                <InputGridElement
                    colStart={{default: 1, s: 3, m: 3}}
                    colEnd={{default: 8, s: 14, m: 8}}
                    rowStart={{default: 4}}
                >
                    <InputField 
                        id="firstName"
                        label={WP.trans.firstName}
                        type="text"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={this.validateField}
                        value={firstName}
                        validated={this.state.firstName}
                    />
                </InputGridElement>
                <InputGridElement
                    colStart={{default: 1, s: 3, m: 9}}
                    colEnd={{default: 8, s: 14, m: 14}}
                    rowStart={{default: 5, m: 4}}
                >
                    <InputField 
                        id="lastName"
                        label={WP.trans.lastName}
                        type="text"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={this.validateField}
                        value={lastName}
                        validated={this.state.lastName}
                    />
                </InputGridElement>
                <InputGridElement
                    colStart={{default: 1, s: 3, m: 3}}
                    colEnd={{default: 8, s: 14, m: 8}}
                    rowStart={{default: 6, m: 5}}
                >
                    <InputField 
                        id="email"
                        label={WP.trans.email}
                        type="email"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={(e) => this.validateEmailFormat(e)}
                        value={email}
                        validated={(validEmailFormat && !submitted) || (validEmailFormat && email.length && submitted)}
                    />
                </InputGridElement>
                <InputGridElement
                    colStart={{default: 1, s: 3, m: 9}}
                    colEnd={{default: 8, s: 14, m: 14}}
                    rowStart={{default: 7, m: 5}}
                >
                    <InputField 
                        id="phone"
                        label={WP.trans.phone}
                        type="number"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={this.validateField}
                        value={phone}
                        validated={this.state.phone}
                    />
                </InputGridElement>
                <InputGridElement
                    colStart={{default: 1, s: 3}}
                    colEnd={{default: 8, s: 14}}
                    rowStart={{default: 8, m: 6}}
                >
                    <InputField 
                        id="adress"
                        label={WP.trans.adress}
                        type="text"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={this.validateField}
                        value={adress}
                        validated={this.state.adress}
                    />
                </InputGridElement>
                <InputGridElement
                    colStart={{default: 1, s: 3, m: 3}}
                    colEnd={{default: 8, s: 14, m: 8}}
                    rowStart={{default: 9, m: 7}}
                >
                    <InputField 
                        id="postalCode"
                        label={WP.trans.postal}
                        type="number"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={this.validateField}
                        value={postalCode}
                        validated={this.state.postalCode}
                    />
                </InputGridElement>
                <InputGridElement
                    colStart={{default: 1, s: 3, m: 9}}
                    colEnd={{default: 8, s: 14, m: 14}}
                    rowStart={{default: 10, m: 7}}
                >
                    <InputField 
                        id="city"
                        label={WP.trans.city}
                        type="text"
                        onChange={(e) => this.props.handleOnChange(e)}
                        onBlur={this.validateField}
                        value={city}
                        validated={this.state.city}
                    />
                </InputGridElement>
            </FormGrid>
        )
    }
}

export default ContactForm;

const FormGrid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
    -ms-grid-rows: ${props => props.rows || 'auto'};
    grid-template-rows: ${props => props.rows || 'auto'};

    ${Media.greaterThan('s')`
        -ms-grid-columns: (1fr .67fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .67fr) 1fr;
    `}

    ${Media.greaterThan('m')`
        -ms-grid-columns: (1fr .435fr)[7] 1fr;
        grid-template-columns: repeat(7, 1fr .435fr) 1fr;
    `}
`

const InputGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.contentXL};
    
    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.elementXS};

        &:last-of-type {
            padding-bottom: ${props => props.theme.spacing.elementM};
        }
    `}
`